import React from 'react';
import compose from 'lodash/fp/compose';
import { withPageType } from '@catalogo/core-connect/page-type';
import { withCookies } from '@catalogo/core-connect/cookies';
import { getIn } from 'seamless-immutable';
import { useDeferedHook } from '../hook/login';

export const withLogin = WrappedComponent => {
  const EnhancedLogin = ({ cookies, pageType, publication: { rec1, rec2, rec3 } }) => {
    const recsPositions = [rec1, rec2, rec3];
    const token = getIn(cookies, ['customer.api.token']);
    const nickname = getIn(cookies, ['nickname']);

    const { data, loading } = useDeferedHook({ recsPositions, pageType });

    const recs = getIn(data, ['recommendations', 'components'], {});
    const recsList = Object.keys(recs);
    const hasRecommendations = recsList.some(key => !!recs[key].rule);
    const name = decodeURI(nickname);

    return (
      <WrappedComponent
        token={token}
        name={name}
        hasRecommendations={hasRecommendations}
        loading={loading}
        recs={recs}
        pageType={pageType}
      />
    );
  };

  return compose(withPageType, withCookies)(EnhancedLogin);
};
